import { type } from "@testing-library/user-event/dist/type";

export const SkillsData = [
  {
    type: "Frontend",
    list: [
      {
        name: "ReactJs",
        icon: <i class="devicon-react-original colored"></i>,
      },
      {
        name: "VueJs",
        icon: <i class="devicon-vuejs-plain colored"></i>,
      },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>,
      },
      // {
      //   name: "NextJs",
      //   icon: <i class="devicon-nextjs-original colored"></i>,
      // },
      {
        name: "MaterialUi",
        icon: <i class="devicon-materialui-plain colored"></i>,
      },
      {
        name: "CSS",
        icon: <i class="devicon-css3-plain colored"></i>,
      },
      {
        name: "React Native",
        icon: <i class="devicon-react-plain colored"></i>,
      },
    ],
  },
];
